import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {

  constructor(private http: HttpClient) { }

  getNotification(params?: any) {
//   const url = `${environment.apiUrl}user/builder/execute/glossary?searchKey=${params?.searchKey || ''}&page=${params.page}`;
  const url = `${environment.apiUrl}user/notification/get-notifications?contentPerPage=${params.itemsPerPage}&page=${params.page}&searchKey=${params?.searchKey || ''}`;
  return this.http.get(url);
}



  
}
